import { useEffect, useState } from "react";
import {
	isNotificationSoundMuted,
	NOTIFICATION_SOUND_PREFERENCE_EVENT,
	NOTIFICATION_SOUND_STORAGE_KEY,
	setNotificationSoundMuted,
} from "../../../../../../../../../../shared/utils/notificationSoundPreference";
import "./notification-sound-toggle.scss";

type Props = {
	disabled?: boolean;
};

const VolumeOnIcon = () => (
	<svg viewBox='0 0 16 16' width='16' height='16' aria-hidden='true'>
		<path
			fill='#000'
			d='M9.5 2.2 6.2 5H3.5A1 1 0 0 0 2.5 6v4a1 1 0 0 0 1 1h2.7l3.3 2.8V2.2ZM11.1 4.6a4.5 4.5 0 0 1 0 6.8.7.7 0 1 0 .9-1.1 3.1 3.1 0 0 0 0-4.6.7.7 0 1 0-.9-1.1Zm2.2-2.1a7 7 0 0 1 0 10.5.7.7 0 1 0 .9-1.1 5.6 5.6 0 0 0 0-8.3.7.7 0 1 0-.9-1.1Z'
		/>
	</svg>
);

const VolumeOffIcon = () => (
	<svg viewBox='0 0 16 16' width='16' height='16' aria-hidden='true'>
		<path
			fill='#000'
			d='M9.5 2.2 6.2 5H3.5A1 1 0 0 0 2.5 6v4a1 1 0 0 0 1 1h2.7l3.3 2.8V2.2Z'
		/>
		<path
			fill='#000'
			d='M2.1 2.1a.7.7 0 0 0 0 1l11.8 11.8a.7.7 0 0 0 1-1L3.1 2.1a.7.7 0 0 0-1 0Z'
		/>
	</svg>
);

export const NotificationSoundToggle = ({ disabled = false }: Props) => {
	const [isMuted, setIsMuted] = useState(() => isNotificationSoundMuted());

	useEffect(() => {
		const onPreferenceChanged = (event: Event) => {
			const customEvent = event as CustomEvent<{ muted: boolean }>;
			setIsMuted(Boolean(customEvent.detail?.muted));
		};

		const onStorage = (event: StorageEvent) => {
			if (event.key !== NOTIFICATION_SOUND_STORAGE_KEY) return;
			setIsMuted(event.newValue === "true");
		};

		window.addEventListener(
			NOTIFICATION_SOUND_PREFERENCE_EVENT,
			onPreferenceChanged,
		);
		window.addEventListener("storage", onStorage);

		return () => {
			window.removeEventListener(
				NOTIFICATION_SOUND_PREFERENCE_EVENT,
				onPreferenceChanged,
			);
			window.removeEventListener("storage", onStorage);
		};
	}, []);

	const tooltip = isMuted
		? "Увімкнути звук повідомлень"
		: "Вимикає звук повідомлень";

	return (
		<button
			type='button'
			className={`history__sound-toggle ${disabled ? "freeze-ui" : ""} ${isMuted ? "history__sound-toggle--muted" : ""}`}
			title={tooltip}
			aria-label={tooltip}
			aria-pressed={isMuted}
			disabled={disabled}
			onClick={(event) => {
				event.stopPropagation();
				const nextMuted = !isMuted;
				setNotificationSoundMuted(nextMuted);
				setIsMuted(nextMuted);
			}}>
			{isMuted ? <VolumeOffIcon /> : <VolumeOnIcon />}
		</button>
	);
};
